module.exports = __webpack_public_path__ + "img/242.9e1132f1.jpg";